import { EuiNotificationBadge } from "@elastic/eui";

const BadgeCount = ({ number }: { number: number }) => {
  return <EuiNotificationBadge style={{ color: "#fff" }}>{number}</EuiNotificationBadge>;
};

export default BadgeCount;
